import {
  Button,
  Div,
  Modal,
  P,
  PropsModal,
} from '@vgrubs/components';
import { VDriveCallTranscriptionResponse } from 'components/src/types/deliveries.types';

export const ReadTranscriptionModal = ({
  modalIsOpen,
  closeModal,
  data,
  customerName,
}: PropsModal & {
  modalIsOpen: boolean;
  data: VDriveCallTranscriptionResponse[] | null;
  customerName: string;
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Transcription"
      textAlign="left"
    >
      <Div>
        {data?.map((item) => (
          <Div key={item.text}>
            <P $m="0 0 4px 0">
              <b>
                {item.speaker === 'ai' ? 'AI Agent: ' : customerName + ': '}
              </b>
              {item.text}
            </P>
          </Div>
        ))}
      </Div>
      <Button $selected $w="100%" $mt="32" $gray onClick={closeModal}>
        Close
      </Button>
    </Modal>
  );
};
